import React, { PropsWithChildren } from "react";
import { ReactComponent as CircleInfoSolidIcon } from "../../assets/icons/font-awesome/circle-info-solid.svg";
const Info = ({ children }: PropsWithChildren) => {
  return (
    <div className="pl-6 pr-16 py-8 rounded-8 bg-darwin-accent-bright-yellow-200 flex space-x-4 text-12 font-400 leading-16 text-darwin-neutral-1000 items-center">
      <CircleInfoSolidIcon className="w-18 h-18 text-darwin-accent-bright-yellow-800" />
      {children}
    </div>
  );
};

export default Info;
